import React from 'react';
import {
  SEVERITY_CLASS,
  STATUS_CLASS,
  SEVERITY_OPTIONS,
  STATUS_OPTIONS,
  CATEGORY_OPTIONS,
  labelFor
} from '../constants';
import styles from '../issues.module.css';

export const SeverityBadge = ({ value }) =>
  value ? (
    <span className={`${styles.badge} ${styles[SEVERITY_CLASS[value]] || ''}`}>
      {labelFor(SEVERITY_OPTIONS, value)}
    </span>
  ) : null;

export const StatusBadge = ({ value }) =>
  value ? (
    <span className={`${styles.badge} ${styles[STATUS_CLASS[value]] || ''}`}>
      {labelFor(STATUS_OPTIONS, value)}
    </span>
  ) : null;

export const CategoryTag = ({ value }) =>
  value ? <span className={styles.categoryTag}>{labelFor(CATEGORY_OPTIONS, value)}</span> : null;

export const JiraLink = ({ jira_key, jira_url }) => {
  if (!jira_key) return null;
  if (!jira_url) return <span className={styles.jiraPlain}>{jira_key}</span>;
  return (
    <a
      className={styles.jiraLink}
      href={jira_url}
      target="_blank"
      rel="noreferrer noopener"
      onClick={(e) => e.stopPropagation()}
    >
      {jira_key}
    </a>
  );
};
